/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { SuggestionSource } from './SuggestionSource.js';
import {
    SuggestionSourceFromJSON,
    SuggestionSourceFromJSONTyped,
    SuggestionSourceToJSON,
} from './SuggestionSource.js';
import type { Value } from './Value.js';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value.js';

/**
 * 
 * @export
 * @interface Suggestion
 */
export interface Suggestion {
    /**
     * 
     * @type {number}
     * @memberof Suggestion
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Suggestion
     */
    fieldId?: number;
    /**
     * 
     * @type {Value}
     * @memberof Suggestion
     */
    value?: Value;
    /**
     * 
     * @type {number}
     * @memberof Suggestion
     */
    score?: number;
    /**
     * 
     * @type {Array<SuggestionSource>}
     * @memberof Suggestion
     */
    sources?: Array<SuggestionSource>;
}

/**
 * Check if a given object implements the Suggestion interface.
 */
export function instanceOfSuggestion(value: object): boolean {
    return true;
}

export function SuggestionFromJSON(json: any): Suggestion {
    return SuggestionFromJSONTyped(json, false);
}

export function SuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Suggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
        'value': json['value'] == null ? undefined : ValueFromJSON(json['value']),
        'score': json['score'] == null ? undefined : json['score'],
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(SuggestionSourceFromJSON)),
    };
}

export function SuggestionToJSON(value?: Suggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fieldId': value['fieldId'],
        'value': ValueToJSON(value['value']),
        'score': value['score'],
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(SuggestionSourceToJSON)),
    };
}

